<template>

  <table class="page-header" style="width:100%;margin-bottom:40px">

    <tr>

      <td>

        <img src="/static/report/logo.png" height="50px" />

      </td>

      <td class="text-right">
         Mese:
        <span class="month-name">{{ monthName }}</span>
         {{ year }}
      </td>

    </tr>

    <tr>

      <td colspan="2" style="border-bottom:2px solid #089BAF"></td>

    </tr>

  </table>

</template>

<script>
 var moment = require('moment'); export default { name: "PageHeader", props: ['month'], computed: { monthName() { return
moment(this.month, 'MM-YYYY').format('MMMM') }, year() { return moment(this.month, 'MM-YYYY').format('YYYY') } } }
</script>

<style scoped>
td {
  padding-bottom: 10px;
}
.month-name {
  text-transform: capitalize;
}
</style>




// WEBPACK FOOTER //
// src/components/Report/0_Header.vue